import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <MediaSection />
        <TopicsSection />
        <FeaturesSection />
        <AboutSection />
        <UpdatesSection />
        <FaqSection />
        <RankingSection />
        <CardsSection />
        <AppSection />
        <ContactSection />
        <CommentsSection />
        <IndexSection />
      </main>
      <Footer />
    </div>
  );
}